<template>
  <div class="animate-spin">
    <icon icon="mdi-loading"></icon>
  </div>
</template>

<script setup lang="ts">
import Icon from "./Icon.vue";

export interface ProgressCircularProps {
  size: number;
}
</script>